module.exports = __webpack_public_path__ + "img/hr-artillery-wagon-base-shadow-2.95d652c6.png";